<div *ngIf="isEditMode; else readModeBlock" class="edit-mode">
  <form [formGroup]="editForm">
    <span matLine class="label">{{ label }}</span>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        (click)="onSaveClicked()"
        [disabled]="!(editForm.valid && editForm.dirty)"
      >
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">check</mat-icon> Save
      </button>
      <button type="button" mat-stroked-button (click)="toggleEditMode(false)">
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">close</mat-icon> Cancel
      </button>
    </div>
    <mat-form-field appearance="outline" class="value-description">
      <mat-select formControlName="description" placeholder="Select tenant timezone">
        <mat-option *ngFor="let timezone of lineupTimeZones" [value]="timezone.name">
          {{ timezone.displayName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="editForm?.get('description').hasError('required')"> Timezone selection is required. </mat-error>
    </mat-form-field>
  </form>
</div>

<ng-template #readModeBlock>
  <div class="read-mode">
    <span matLine class="label">{{ label }}</span>
    <div class="value-description">
      <span *ngIf="displayName" matLine>{{ displayName }}</span>
    </div>
    <div class="button-container" *ngIf="!readOnly">
      <button mat-stroked-button (click)="toggleEditMode(true)" aria-label="Edit">
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">edit</mat-icon> Edit
      </button>
    </div>
  </div>
</ng-template>
